export function evaluate(path: string, data: Record<string, any>): string {
    if (!path) return null;

    const regex = /\{\{(.*?)\}\}/g;
    return path.replace(regex, (match, p1) => {
        const keys = p1.split(".");
        let value = data;

        for (const key of keys) {
            if (value) {
                const lowerCaseSearchKey = key.toLowerCase();
                const foundKey = Object.keys(value).find(key => key.toLowerCase() === lowerCaseSearchKey);
                value = value[foundKey];
            } else {
                return ""; // Return the original match if the key is not found
            }
        }

        return value !== undefined ? String(value) : ""; // Convert to string or return original match
    });
}